import { MessageSquare } from "lucide-react"
import { Button } from "@/components/ui/Button"

type CommentProps = {
  colors?: string[]
  author: string
  timestamp: string
  content: string
}

export function Comment({ author, timestamp, content, colors }: CommentProps) {
  return (
    <div className="rounded-2xl bg-muted/50 p-4">
      <div className="flex items-start gap-3">
        <div className="shrink-0">
          <CommentAvatar colors={colors} />
        </div>
        <div className="flex-1 space-y-1">
          <div className="flex items-center gap-2">
            <span className="font-medium text-sm">{author}</span>
            <span className="text-xs text-muted-foreground">{timestamp}</span>
          </div>
          <p className="text-sm text-muted-foreground">{content}</p>
          <div className="flex items-center gap-2 mt-2">
            <Button variant="ghost" size="sm" className="h-7 text-xs">
              Reply
            </Button>
            <Button variant="ghost" size="sm" className="h-7 text-xs">
              Resolve
            </Button>
          </div>
        </div>
        <MessageSquare className="size-4 text-muted-foreground mt-1 shrink-0" />
      </div>
    </div>
  )
}

const CommentAvatar = ({ colors = ['#c6c887', '#929460'] }: { colors?: string[] }) => {
  return (
    <div 
      style={{
        '--bg-color-top': colors?.[0],
        '--bg-color-bottom': colors?.[1],
      } as React.CSSProperties}
      className="size-6 rounded-full bg-linear-to-b from-(--bg-color-top) to-(--bg-color-bottom) flex items-center justify-center">
      
    </div>
  )
}

